const messages = {
  title: "Apkopes darbi!",
  description:
    'Pašlaik serveros tiek veikti nepieciešamie apkopes darbi.<br/><br/>Tāpēc jums pašlaik nav piekļuves <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>Lūdzam jūsu pacietību un pateicamies par sapratni.<br/><br/> Jūsu Bridgestone komanda',
}
export default {
  messages
}
